module.exports = __webpack_public_path__ + "static/media/B4.bf2b6915.jpg";